import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';
import './webinar-sign-up.styles.scss';

function NewWebinarSignupLandingPage({
  page: { MainContent, breadCrumbList },
}) {
  const HeroComponent = React.lazy(() =>
    import('./new-webinar-sign-up-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-webinar-sign-up-content-component')
  );

  return (
    <div className="webinar-container">
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent MainContent={MainContent} />
      </Suspense>
    </div>
  );
}

export default NewWebinarSignupLandingPage;
